import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ActivityWeekCard, uiLocale, weekdaysShortMonFirst } from '@wehunt/ui'
import { useChronicleOverview, RANGE_OPTIONS, DEFAULT_RANGE, type RangeDays } from './useChronicleOverview'

const STORAGE_KEY = 'wehunt:chronicle:activityDays'
// The empty-state placeholder labels the overview hook emits; when present we
// swap in localized weekday names (real backend labels pass through unchanged).
const PLACEHOLDER_WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].join()

function readStoredRange(): RangeDays {
  if (typeof window === 'undefined') return DEFAULT_RANGE
  const raw = window.localStorage.getItem(STORAGE_KEY)
  const n = raw ? Number(raw) : NaN
  return (RANGE_OPTIONS as readonly number[]).includes(n) ? (n as RangeDays) : DEFAULT_RANGE
}

export function ChronicleActivityPanel() {
  const { i18n } = useTranslation('overview')
  const [days, setDays] = useState<RangeDays>(readStoredRange)
  const { activity } = useChronicleOverview(days)
  const labels =
    activity.barLabels.join() === PLACEHOLDER_WEEKDAYS
      ? weekdaysShortMonFirst(uiLocale(i18n.language))
      : activity.barLabels

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, String(days))
    }
  }, [days])

  return (
    <ActivityWeekCard
      bars={activity.bars}
      labels={labels}
      highlightIndex={activity.highlightIndex}
      gameReported={activity.gameReported}
      hoursInField={activity.hoursInField}
      mapPins={activity.mapPins}
      participants={activity.participants}
      rangeOptions={[...RANGE_OPTIONS]}
      selectedRange={days}
      onRangeChange={(d) => setDays(d as RangeDays)}
    />
  )
}
